/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Moderationconversationgroup2Inputs */

const en_moderationconversationgroup2 = /** @type {(inputs: Moderationconversationgroup2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Group`)
};

const de_moderationconversationgroup2 = /** @type {(inputs: Moderationconversationgroup2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gruppe`)
};

/**
* | output |
* | --- |
* | "Group" |
*
* @param {Moderationconversationgroup2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const moderationconversationgroup2 = /** @type {((inputs?: Moderationconversationgroup2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Moderationconversationgroup2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_moderationconversationgroup2(inputs)
	return de_moderationconversationgroup2(inputs)
});
export { moderationconversationgroup2 as "moderationConversationGroup" }